import React from 'react'
import Navbar from "../components/Navbar";
import HeroImg from "../components/Heroimg";
import Footer from "../components/Footer";


const home = () => {
  return (
    <div>
      <Navbar/>
      <HeroImg />
      <Footer />
    </div>
  )
}

export default home

